import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import DepartmentListPage from './pages/DepartmentListPage';

export const departmentModule: ModuleDefinition = {
  routes: [{ path: 'corporate/department', element: <DepartmentListPage /> }],
  menuItems: [
    {
      label: 'Kurumsal: Departmanlar',
      path: 'corporate/department',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
